import { render } from "./Menu.vue?vue&type=template&id=41e10344&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=41e10344&lang=scss&scoped=true"

import exportComponent from "/proyectos/vue_institucional/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41e10344"]])

export default __exports__